const Colors = {
    whatsgreen: "#4AAE20",
    minze: "#6CC751",
    sommerwald: "#225F1E",
    sonnenschein: "#F8CC07",
    mandarine: "#FF9300",
    zinnober: "#E44436",
    fuchsia: "#CD3292",
    himmelblau: "#37AEF3",
    bleuDeFrance: "#0076BA",
    saphirblau: "#005888",
    orchidee: "#8732CD",
    text: "#33482C",
    lightText: "#FFFFFF",
    lightGray: "rgba(0,0,0,0.12)",
    gray: "rgba(0,0,0,0.38)",
    darkGray: "rgba(0,0,0,0.54)",
    darkerGray: "rgba(0,0,0,0.87)",
};

export default Colors;


// WEBPACK FOOTER //
// ./src/components/CustomColors.js